import React from 'react'

function Building() {
 return (
   <>
     <div>
       <div className="flex flex-col  items-start sm:px-16 p-6">
         <h1 className="text-[1.9rem] font-bold tracking-wide text-[#26323F]">
           Care of the Building, Common Areas and Rooms:
         </h1>
         <ol
           className="list-decimal text-md text-[#444444] tracking-wide pt-3 flex flex-col gap-4  px-6"
           type="1"
         >
           <li>
             Vandalism is a serious offence. Vandalism means and includes any
             and all acts of destruction, damage, and/or defacement of any asset
             or property owned by Yostel. The residents found guilty of
             committing such an offence can be evicted from the property and be
             required to pay all costs incurred by Yostel due to such damage or
             destruction.
           </li>
           <li>
             Any items of common use (e.g. microwave, iron, kettle, induction
             top, magazines, crockery, common TV units, etc) provided by Yostel
             as part of the amenities package, shall be used only in the common
             areas and not in individual rooms.{" "}
           </li>
           <li>
             {" "}
             No furniture or furnishings in the common areas of the House may be
             moved by the residents at any point of time.
           </li>
           <li>
             {" "}
             Any damage to the House must be reported by the residents
             immediately to the Yostel Representatives. The residents will be
             liable to pay for the expenses or costs arising from use/misuse of
             the same by the resident, except for damages caused by normal wear
             and tear.{" "}
           </li>
           <li>
             The residents must keep the keys of their rooms and wardrobes safe
             with them. In case of loss, they will have to bear the cost of
             replacement of keys. The locks for the wardrobes and/or the room
             are not allowed to be changed.{" "}
           </li>
           <li>
             Even in very special cases when the resident is permitted to change
             or put an additional lock on the room door by the Yostel
             representative, the resident must ensure that one set of the room
             keys are submitted to their respective roommate(s) and the Yostel
             Residence Captain for regular Housekeeping, R&M requirements, and
             any emergency situations.
           </li>
         </ol>
       </div>
     </div>
   </>
 );
}

export default Building
